import { Engine } from '../../core/Engine';
import { GraphicElement } from '../../entities/Drawable/GraphicElement';
import { UpdateCommand, UpdateType } from '../Commands';
import { ImageSVG } from '../../entities/Drawable/ImageSVG';
import { Image } from '../../entities/Drawable/Image';
import { Group } from '../../entities/Drawable/Group';
import { ColorGroup } from '../../entities/ColorGroup';

export class UpdateCommandHandler {
    private engine: Engine;

    constructor(engine: Engine) {
        this.engine = engine;
    }

    handle(command: UpdateCommand) {
        const obj: GraphicElement = this.engine.find(command.uuid);

        if (command.value && Object.keys(command.value).length !== 0) {
            for (const type in command.value) {
                if (type === UpdateType.colorGroups) {
                    if (!(obj instanceof Group)) {
                        throw 'Error during update ' + type;
                    }
                    command.value.colorGroups.forEach((colorGroup: ColorGroup) => {
                        (<Group>obj).addOrReplaceColorGroup(colorGroup);
                    });
                } else if (type === UpdateType.content) {
                    obj.content = command.value.content;
                    if (obj instanceof Image) {
                        obj.originalContent = obj.content.duplicate();
                    }
                } else if (type === UpdateType.options) {
                    obj.addOrReplaceOptions(command.value.options);
                } else if (type === UpdateType.scale) {
                    obj.transform.resize(command.value.scale, true);
                } else if (type === UpdateType.size) {
                    obj.originSize = command.value.size;
                } else if (type === UpdateType.position) {
                    obj.transform.moveTo(command.value.position, true);
                }
            }
        } else {
            // to be deprecated
            if (obj instanceof Image) {
                obj.update(command.content, command.options, command.scale, command.size);
            } else {
                obj.update(command.content, command.options, command.scale);
            }
        }
    }
}
